import { useState, useMemo, useCallback } from "react";

export const hookGlobalCustomFieldsFactory = () => ({ fetch, siteSelected: { id: siteId } }) => {
  const [formsToSync, setFormsToSync] = useState([])

  const resetFormsToSync = useCallback(() => setFormsToSync([]), [])

  const parseData = useCallback(data => data.map(field => ({
    ...field,
    key: `cf_${field.key}`,
    group: 'Custom Fields',
  })), [])

  const parseParams = useCallback(({ attachedToSite = true, ...params }) => ({
    ...params, siteId, attachedToSite }
  ), [siteId])

  const getFields = useCallback(async ({ parse, ...params } = {}) => {
    const data = await fetch({
      url: `/customFields/all`,
      params: parseParams(params),
    })
    return parse ? parseData(data) : data
  }, [fetch, parseParams, parseData])

  return useMemo(() => ({
    customFields: {
      formsToSync, setFormsToSync, resetFormsToSync, getFields,
    },
  }), [formsToSync, setFormsToSync, resetFormsToSync, getFields])
}
